import 'waypoints/lib/noframework.waypoints.min.js';
import './components/parallax'

const events = document.querySelectorAll('.timeline__event')

events.forEach(el => {
  new Waypoint({
    element: el,
    handler: () => {
      el.classList.add('active')

      setTimeout(() => {
        el.querySelector('.timeline__feature').classList.add('active')
      }, 500)
    },
    offset: '70%'
  })
})
